export const SET_PAGINATION = "SET_PAGINATION"
export const SET_PAGE_NUMBER = "SET_PAGE_NUMBER"
export const SET_DATA_IN_ONEPAGE = "SET_DATA_IN_ONEPAGE"
export const SET_TOTAL_NO_RESULT = "SET_TOTAL_NO_RESULT"